import type { MouseEvent } from 'react';

import SaveAlt from '@mui/icons-material/SaveAlt';
import type { Sx } from '@/shared/types/uiTypes';

import WidgetButton from '@/shared/ui/primitives/WidgetButton';

const ExportButton = ({
  title,
  disabled,
  handleClick,
  sx,
  iconSize = 16
}: {
  title: string;
  disabled?: boolean;
  handleClick: (event: MouseEvent) => void;
  sx?: Sx;
  iconSize?: number;
}) => (
  <WidgetButton
    disabled={disabled}
    icon={<SaveAlt sx={{ fontSize: iconSize }} />}
    sx={sx}
    title={title}
    onClick={handleClick}
  />
);

export default ExportButton;
